import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import global_config from '@/../config.json'

// Symmetric aliases applied when the requested payload is not present in config.json.
const languageAliases = {
  putonghua: 'mandarin',
  mandarin: 'putonghua'
}

const normalizeLanguagePayload = (requested) => {
  if (!requested || !global_config.languages?.length) return null
  const hasPayload = (p) => global_config.languages.some((l) => l.payload === p)
  if (hasPayload(requested)) return requested
  const alias = languageAliases[requested]
  if (alias && hasPayload(alias)) return alias
  return null
}

const routes = [
  {
    path: '/:catchAll(.*)',
    name: 'All',
    redirect: (to) => {
      const normalized = normalizeLanguagePayload(to.query.language)
      return { path: '/language', query: normalized ? { language: normalized } : {} }
    }
  },
  {
    path: '/language',
    name: 'LanguageSelection',
    component: () => import(/* webpackChunkName: "language" */ '../views/LanguageSelection/index.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import(/* webpackChunkName: "chat" */ '../views/Chat/index.vue')
  },
  {
    path: '/disclaimer/:language',
    name: 'Disclaimer',
    component: () => import(/* webpackChunkName: "disclaimer" */ '../views/Disclaimer/index.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  try {
    const language = normalizeLanguagePayload(to.query.language)
    const { default_language = null } = global_config
    const selected_language = store.state.i18n.socket_language

    let next_params = {}

    if (Object.keys(to.query).length > 0) {
      const socketQueries = { ...to.query }
      delete socketQueries.language
      if (Object.keys(socketQueries).length > 0) {
        store.commit('ADD_SOCKET_ADDITIONAL_QUERY_PARAMS', socketQueries)
      }

      Object.keys(to.query).forEach((query) => {
        delete to.query[query]
      })
      next_params = { ...to, query: { ...to.query } }
    }

    if (to === from) return // Avoid redirect to same page
    else if (from.name === 'Chat') return // Avoid user back to previous page from home page
    else if (to.name === 'Chat' && from.name !== 'LanguageSelection' && !selected_language) next_params = { path: '/language' } // Avoid user access chat page directly

    const resolvedLanguage = language || selected_language || default_language
    // `SET_I18N_LANGUAGE` updates `i18n.language`; App.vue applies it to the
    // Vuetify locale centrally, so no per-call locale assignment is needed here.
    store.commit('SET_I18N_LANGUAGE', resolvedLanguage)
    if ((language || default_language) && to.name === 'LanguageSelection') next_params = { path: '/chat' }
    if (JSON.stringify(next_params) === '{}') next()
    else next(next_params)
  } catch (error) {
    console.log(`Route Error: ${error.message}`)
  }
})

export default router
